window.addEventListener("DOMContentLoaded", () => {
    
    // Adds parameters to buttons to prefill GF quote form
    let quoteButtons = document.getElementsByClassName('quote-button');

    console.log(quoteButtons);
    

    if( quoteButtons ){
        Array.from(quoteButtons).forEach( button => {

            // only works project single page
            if( ! document.body.classList.contains('single-projects') ) return;

            if( button.tagName != 'A' ){
                button = button.querySelector('a');
            }

            addQuoteButtonParameters(button);
            
        } );
    }

});


async function addQuoteButtonParameters(button){

    if( !button || button.tagName != 'A' ) return;

    const baseURL = button.href;
    if(!baseURL) return;

    // get page post ID 
    let postID = getPostIDFromBody();
    if(!postID) return;

    try {
        const response = await fetch( `${restApi.url}custom/v1/params/?post=${postID}`, {
            method: 'GET',
            headers: { 'X-WP-Nonce': restApi.nonce }
        });

        if (!response.ok) {
            throw new Error('Failed fetching params');
        }

        const data = await response.json();

        if(!data.body) return;

        const url = new URL(baseURL);
        
        Object.entries(data.body).forEach(([key, value]) => {
            url.searchParams.set(key, value);
        });

        button.href = url.toString();

    } catch (error) {
        console.error('Error:', error);
    }

}

// Gets post ID from body classes
function getPostIDFromBody(){
    const bodyClasses = document.body.classList;
    for (const bodyClass of bodyClasses) {
        if (bodyClass.startsWith('postid-')) {
            return bodyClass.replace('postid-', '');
        }
    }
    return null;
}

